import { connect } from 'react-redux';
import Value, { ValueProps } from '@/pages/CompanyReport/components/Value';
import getValueSelector from '@/pages/CompanyReport/components/Value/redux/selectors';
import { shouldSkipDefer } from '@ducks/ui/selectors/shouldSkipDefer';

type ContainerProps = Partial<Pick<ValueProps, 'sectionNumber' | 'companyId'>>;
const mapStateToProps = (state, ownProps: ContainerProps): ValueProps => {
  const value = getValueSelector(state, ownProps);
  const skipDefer = shouldSkipDefer(state);
  return {
    /** market */
    mpe: value.mpe,
    mpb: value.mpb,
    /** industry */
    ipe: value.ipe,
    ipb: value.ipb,
    /** stuff */
    pe: value.pe,
    pb: value.pb,
    peg: value.peg,
    isFund: value.isFund,
    keyMetric: value.keyMetric,
    keyMetricTitle: value.keyMetricTitle,
    companyId: value.companyId,
    uniqueSymbol: value.uniqueSymbol,
    companyName: value.companyName,
    tickerSymbol: value.tickerSymbol,
    intrinsicValue: value.intrinsicValue,
    marketName: value.marketName,
    industryName: value.industryName,
    sharePrice: value.sharePrice,
    intrinsicDiscount: value.intrinsicDiscount,
    intrinsicDiscountFormatted: value.intrinsicDiscountFormatted,
    intrinsicValueFormatted: value.intrinsicValueFormatted,
    sharePriceFormatted: value.sharePriceFormatted,
    skipDefer,
  };
};

export default connect<ValueProps, undefined, ContainerProps>(mapStateToProps)(
  Value
);
